// extracted by mini-css-extract-plugin
export default {"bottomStyles":"StatisticalRanking_bottomStyles__aF8Bl","carbonRadio":"StatisticalRanking_carbonRadio__1ELcK"};